module.exports = __webpack_public_path__ + "static/media/carrara-bol-webfont.55f01b21.woff";